import { useSelector } from "react-redux"

import { selectIncognito } from "../Utils/incognito"

// Is Incognito mode currently masking values?
export const useIncognito = () => useSelector(selectIncognito)
